import {Group, Select, Text, ThemeIcon} from "@mantine/core";
import classes from "./SettingSelectField.module.css";
import {useTranslation} from "react-i18next";
import {chatApi} from "../../chatApi";
import {
    getApiLanguageCode,
    LanguageCode,
} from "../../../../types";
import IconNorway from "../../../../assets/flag-no.svg?react";
import IconSweden from "../../../../assets/flag-se.svg?react";
import IconDenmark from "../../../../assets/flag-dk.svg?react";
import IconUnitedKingdom from "../../../../assets/flag-gb.svg?react";

const flagMap = {
    nb: <IconNorway />,
    en: <IconUnitedKingdom />,
    sv: <IconSweden />,
    da: <IconDenmark />,
};

export function LanguageSelectField() {
    const [updateSettings] = chatApi.endpoints.updateSettings.useMutation();

    const {t, i18n} = useTranslation();
    const activeLanguage = i18n.resolvedLanguage ?? i18n.language;
    const handleChange = async (value: string | null) => {
        const newLanguage = value ?? LanguageCode.Norwegian;

        i18n.changeLanguage(newLanguage);

        // Persist to backend via settings API
        await updateSettings({
            preferredLanguage: getApiLanguageCode(newLanguage),
        });
    };

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>{t("settings.language")}</Text>
            <Select
                className={classes.innerItem}
                leftSection={
                    <ThemeIcon
                        variant="light"
                        size="sm"
                        radius="xl"
                        color="gneis.8"
                        bg="transparent"
                    >
                        {flagMap[activeLanguage as keyof typeof flagMap]}
                    </ThemeIcon>
                }
                data={[
                    {value: LanguageCode.Norwegian, label: "Norsk"},
                    {value: LanguageCode.English, label: "English"},
                    {value: LanguageCode.Swedish, label: "Svenska"},
                    {value: LanguageCode.Danish, label: "Dansk"},
                ]}
                value={activeLanguage}
                onChange={handleChange}
            />
        </Group>
    );
}
